export default __webpack_public_path__ + "static/media/sheets-logo.54bc492e.svg";